import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, Loader2, XCircle } from "lucide-react";
import { Wordmark } from "@/components/Logo";
import { api, money } from "@/lib/api";

export default function PaymentSuccess() {
  const [sp] = useSearchParams();
  const sid = sp.get("session_id");
  const [state, setState] = useState({ status: "checking" });

  useEffect(() => {
    if (!sid) return undefined;
    let tries = 0;
    let timer;
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/status/${sid}`);
        if (data.payment_status === "paid") return setState({ status: "paid", ...data });
        if (data.payment_status === "expired" || data.status === "expired") return setState({ status: "failed" });
      } catch (e) {
        /* keep polling */
      }
      tries += 1;
      if (tries < 15) timer = setTimeout(poll, 2000);
      else setState({ status: "timeout" });
      return undefined;
    };
    poll();
    return () => clearTimeout(timer);
  }, [sid]);

  const inv = state.invoice;
  return (
    <div className="min-h-screen bg-[#FFF7FB] px-5 py-10" data-testid="payment-success-page">
      <div className="mx-auto max-w-lg">
        <Wordmark />
        <div className="mt-16 rounded-3xl border border-[#2A1240]/10 bg-[#FFFFFF] p-8 text-center">
          {state.status === "checking" && <><Loader2 className="mx-auto h-10 w-10 animate-spin text-[#E0218A]" /><p className="mt-4 text-slate-300" data-testid="payment-checking">Confirming your payment…</p></>}
          {state.status === "paid" && (
            <>
              <CheckCircle2 className="mx-auto h-12 w-12 text-emerald-300" />
              <h1 className="mt-4 font-display text-3xl text-[#2A1240]" data-testid="payment-paid">Payment received</h1>
              {state.purpose === "ad" && <p className="mt-3 text-slate-300" data-testid="payment-ad-note">Thanks! Your Featured ad is waiting for approval. We'll let you know as soon as it's live.</p>}
              {inv && <p className="mt-3 text-slate-300">{inv.number} · {inv.title} · <span className="font-mono">{money(inv.total, 2)}</span><br />Receipt {inv.receipt_number}</p>}
            </>
          )}
          {(state.status === "failed" || state.status === "timeout") && (
            <><XCircle className="mx-auto h-12 w-12 text-red-300" /><p className="mt-4 text-slate-300" data-testid="payment-failed">{state.status === "failed" ? "This checkout expired." : "We couldn't confirm the payment yet. Check back shortly."}</p></>
          )}
          <Link to={state.purpose === "ad" ? "/app/promote" : "/app"} className="btn-ghost mt-8" data-testid="payment-back-link">Back to dashboard</Link>
        </div>
      </div>
    </div>
  );
}
